// Redressement vidéo : angle interpolé et lissé à un instant du média, sans retard.
// Même algorithme que l'app (RotationCues.kt) : interpolation entre le cue précédent
// ET le suivant (déjà en mémoire tampon), puis moyenne pondérée centrée sur ±100 ms
// autour de l'image affichée. Les paliers d'un degré et les tremblements du capteur
// sont gommés sans décaler la correction par rapport à l'image.

const HALF_WINDOW_S = 0.1;
const STEPS = 4;
const STEP_S = HALF_WINDOW_S / STEPS;
// Au-delà d'un trou (coupure, téléphone immobile), pas d'interpolation sur sa durée.
const MAX_GAP_S = 1.5;

function shortestDelta(from, to) {
    let delta = (to - from) % 360;
    if (delta > 180) delta -= 360;
    if (delta < -180) delta += 360;
    return delta;
}

/** Index du dernier cue dont le pts est <= time (-1 si aucun). cues triés par pts. */
function lastCueIndexAt(cues, time) {
    let low = 0;
    let high = cues.length;
    while (low < high) {
        const mid = (low + high) >>> 1;
        if (cues[mid].pts <= time) low = mid + 1;
        else high = mid;
    }
    return low - 1;
}

function interpolatedAt(cues, time) {
    const index = lastCueIndexAt(cues, time);
    if (index < 0) return cues[0].rot;
    if (index >= cues.length - 1) return cues[cues.length - 1].rot;
    const c0 = cues[index];
    const c1 = cues[index + 1];
    if (c1.pts - c0.pts > MAX_GAP_S || c1.pts === c0.pts) return c0.rot;
    const fraction = (time - c0.pts) / (c1.pts - c0.pts);
    return c0.rot + shortestDelta(c0.rot, c1.rot) * fraction;
}

/**
 * Angle lissé (0..360) à l'instant `time` (secondes, horloge du média) ; null sans cue.
 * @param {{pts: number, rot: number}[]} cues triés par pts croissant
 */
export function smoothedRotationAt(cues, time) {
    if (!Array.isArray(cues) || cues.length === 0 || !Number.isFinite(time)) return null;
    const center = interpolatedAt(cues, time);
    let weightedSum = 0;
    let weightTotal = 0;
    for (let k = -STEPS; k <= STEPS; k += 1) {
        const weight = STEPS + 1 - Math.abs(k);
        const sample = interpolatedAt(cues, time + k * STEP_S);
        weightedSum += weight * (center + shortestDelta(center, sample));
        weightTotal += weight;
    }
    return (((weightedSum / weightTotal) % 360) + 360) % 360;
}
